import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1a40c606")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")
  const _component_el_submenu = _resolveComponent("el-submenu")
  const _component_el_menu = _resolveComponent("el-menu")

  return (_openBlock(), _createBlock(_component_el_menu, {
    class: "info-nav",
    mode: "vertical",
    "default-active": "info",
    "text-color": "#8f98a7",
    "active-text-color": "#287cbb",
    "unique-opened": "",
    router: ""
  }, {
    default: _withId(() => [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tags, (tag) => {
        return (_openBlock(), _createBlock(_Fragment, null, [
          (tag.subs)
            ? (_openBlock(), _createBlock(_component_el_submenu, {
                index: tag.index,
                key: tag.index
              }, {
                title: _withId(() => [
                  _createVNode("i", {
                    class: tag.icon
                  }, null, 2),
                  _createTextVNode(" " + _toDisplayString(tag.title), 1)
                ]),
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(tag.subs, (subItem) => {
                    return (_openBlock(), _createBlock(_Fragment, null, [
                      (subItem.subs)
                        ? (_openBlock(), _createBlock(_component_el_submenu, {
                            index: subItem.index,
                            key: subItem.index
                          }, {
                            title: _withId(() => [
                              _createTextVNode(_toDisplayString(subItem.title), 1)
                            ]),
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(subItem.subs, (threeItem, i) => {
                                return (_openBlock(), _createBlock(_component_el_menu_item, {
                                  key: i,
                                  index: threeItem.index
                                }, {
                                  default: _withId(() => [
                                    _createTextVNode(_toDisplayString(threeItem.title), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["index"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["index"]))
                        : (_openBlock(), _createBlock(_component_el_menu_item, {
                            index: subItem.index,
                            key: subItem.index
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(subItem.title), 1)
                            ]),
                            _: 2
                          }, 1032, ["index"]))
                    ], 64))
                  }), 256))
                ]),
                _: 2
              }, 1032, ["index"]))
            : (_openBlock(), _createBlock(_component_el_menu_item, {
                index: tag.index,
                key: tag.index
              }, {
                title: _withId(() => [
                  _createVNode("i", {
                    class: tag.icon
                  }, null, 2),
                  _createTextVNode(" " + _toDisplayString(tag.title), 1)
                ]),
                _: 2
              }, 1032, ["index"]))
        ], 64))
      }), 256))
    ]),
    _: 1
  }))
})